import styled from '@emotion/styled'
import {css} from '@emotion/core'
import {hexToRGBStr} from '@daedalus/core/src/utils/string'

export const StyledPopper = styled('div')<{hasDefaultStyles: boolean}>(
  ({theme, hasDefaultStyles}) =>
    hasDefaultStyles &&
    css`
      padding: ${theme.layout.spacing.s400}px 0;
      background-color: ${theme.colors.popoverBg};
      border-radius: ${theme.layout.radius.lg}px;
      box-shadow: 0 6px 16px 0
        rgba(${hexToRGBStr(theme.colors.cardShadow)}, 0.16); // TODO (@dale-french) [2022-03-16] dq82hd-desktop-map: Migrate to theme or use shadow from theme
      border: 0.5px solid ${theme.colors.popoverBorder};
      z-index: 2;
    `
)
